import { useEffect, useState } from "react";
import * as React from "react";
import { renderMarkdown } from "@libs/utils/markdownRenderer";
import styles from "./index.module.css";

type Props = {
  text: string;
};

const Markdown: React.FC<Props> = ({ text }) => {
  // サーバーサイドではrenderMarkdownが実行できないので、ブラウザでのみ実行する
  const [renderedContent, setRenderedContent] = useState("");
  useEffect(() => {
    setRenderedContent(renderMarkdown(text));
  }, [text]);

  return (
    <div
      className={styles.markdownStyle}
      dangerouslySetInnerHTML={{ __html: renderedContent }}
    />
  );
};

export default Markdown;
